/* GPS Calm JS
   - Removes theme/app page-transition shimmer
   - Removes fake cursor widgets
   No hover logic here; CSS handles outline behaviour.
*/
(function () {
  function calm() {
    try {
      // kill page transition behaviour
      if (document.body) document.body.removeAttribute('data-page-transition');
      document.querySelectorAll('.page-transition, .page-transition__overlay, .loading-bar, .loading-bar__progress')
        .forEach(el => el.remove());

      // kill fake cursors
      document.querySelectorAll('.mouse-cursor').forEach(el => el.remove());
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calm, { once: true });
  } else {
    calm();
  }

  // Re-apply after section reloads in the customiser
  ['shopify:section:load','shopify:section:select','shopify:section:deselect','shopify:section:reorder']
    .forEach(ev => window.addEventListener(ev, calm));
})();
